import qs from 'query-string';

import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

import { useValidateEventUrlCommand } from 'legacy/events/hooks';
import Loader from 'legacy/common/components/layout/Loader';
import Button from 'legacy/common/components/button/Button';

const EventInvite = () => {
  const router = useRouter();
  const eventId = Array.isArray(router?.query?.slug) ? router.query.slug[0] : (router?.query?.slug as string) || '';
  const validateEventUrlCommand = useValidateEventUrlCommand();

  const shareToken = Array.isArray(router.query.invite) ? router.query.invite[0] : (router.query.invite as string) || '';

  const validateEventUrl = () => {
    validateEventUrlCommand.mutate(
      {
        eventId,
        shareToken
      },
      {
        onSuccess: () => {
          if (router?.query?.tierShareToken) {
            const params = qs.stringify({
              tierShareToken: router?.query?.tierShareToken
            });

            router.push(`/events/${eventId}?${params}`);
            return;
          }

          router.push(`/events/${eventId}`);
        }
      }
    );
  };

  useEffect(() => {
    validateEventUrl();
  }, []);

  if (validateEventUrlCommand.isLoading) {
    return (
      <div className="text-center my-40">
        <Loader isLoading />
        <div className="mt-10 text-lg">Validating Invite Link...</div>
      </div>
    );
  }

  if (validateEventUrlCommand.error?.message) {
    return (
      <div className="my-40" data-testid="error-invalid-invite">
        <div className="mt-10 text-lg text-center">
          Error: {validateEventUrlCommand.error?.message}
        </div>

        <div className="mt-10 w-40 mx-auto">
          <Button
            onClick={() => {
              validateEventUrl();
            }}
          >
            Try again
          </Button>
        </div>
      </div>
    );
  }

  return null;
};

export default EventInvite;
